import types from '../actions/types';
import produce from 'immer';

const initialState = {
  lines: [],
  lineCount: 0,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.FACE_ADD_LINE:
      return produce(state, draftState => {
        draftState.lines.push(action.payload.line);
      });
    case types.FACE_UPDATE_LINES:
      return produce(state, draftState => {
        let lastLine = state.lines[state.lines.length - 1];
        // add point
        lastLine.points = lastLine.points.concat([action.payload.points[0], action.payload.points[1]]);

        // replace last
        draftState.lines.splice(draftState.lines.length - 1, 1, lastLine);
        draftState.lineCount++;
      });
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/linesReducer.js